import de from '@translations/de/cataloguesTable.json';
import en from '@translations/en/cataloguesTable.json';
import pl from '@translations/pl/cataloguesTable.json';
import sl from '@translations/sl/cataloguesTable.json';
import uk from '@translations/uk/cataloguesTable.json';
import bg from '@translations/bg/cataloguesTable.json';
import cz from '@translations/cz/cataloguesTable.json';
import fr from '@translations/fr/cataloguesTable.json';
import gr from '@translations/gr/cataloguesTable.json';
import it from '@translations/it/cataloguesTable.json';
import pr from '@translations/pr/cataloguesTable.json';
import ru from '@translations/ru/cataloguesTable.json';
import sk from '@translations/sk/cataloguesTable.json';
import sp from '@translations/sp/cataloguesTable.json';
import tr from '@translations/tr/cataloguesTable.json';
import hu from '@translations/hu/cataloguesTable.json';
import { ITranslations } from '@/types/common';
import { CataloguesTableTransFields } from './types';

export const cataloguesTableTranslations: ITranslations<CataloguesTableTransFields> = {
  name: 'cataloguesTable',
  de,
  en,
  pl,
  sl,
  uk,
  bg,
  cz,
  fr,
  gr,
  it,
  pr,
  ru,
  sk,
  sp,
  tr,
  hu,
};
